import { Controller } from '@hotwired/stimulus'

class CarouselAutoScroll {
  constructor (dots, sliders, interval) {
    this.dots = dots
    this.interval = interval
    this.sliders = sliders
    this.paused = false
  }

  start () {
    this.auto = setInterval(() => {
      if (!this.paused) {
        this.dots.forEach((dot, index) => {
          if (dot.hasAttribute('isCurrent')) {
            this.next(this.sliders[index + 1])
          }
        })
      }
    }, this.interval)
  }

  pause (event) {
    this.paused = true

    clearTimeout(this.pauseInterval)

    this.pauseInterval = setTimeout(() => {
      this.paused = false
    }, 15000)
  }

  restart () {
    this.sliders[0].scrollIntoView({ behavior: 'smooth' })
  }

  stop () {
    clearInterval(this.auto)
  }

  next (slider) {
    if (slider != null) {
      slider.scrollIntoView({ behavior: 'smooth' })
    } else {
      this.restart()
    }
  }
}

export class AutoScrollComposableController extends Controller {
}

const defaultOptions = {
  interval: 5000
}

export const useCarouselAutoScroll = (composableController, dots, sliders, options = {}) => {
  const controller = composableController
  const { interval } = Object.assign({}, defaultOptions, options)

  const controllerDisconnect = controller.disconnect.bind(controller)

  const autoScroll = new CarouselAutoScroll(dots, sliders, interval)
  autoScroll.start()

  const pause = (event) => {
    autoScroll.pause(event)
  }

  const restart = () => {
    autoScroll.restart()
  }

  const stop = () => {
    autoScroll.stop()
  }

  Object.assign(controller, {
    pause,
    restart,
    stop,
    disconnect () {
      stop()
      controllerDisconnect()
    }
  })
}
